module.exports = __webpack_public_path__ + "static/feature-3-88ea4605e210741c84fe673c70395846.png";